"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).on("click", ".question", function () {
  (0, _jquery2.default)(this).next("div").slideToggle();
});

(0, _jquery2.default)(document).on("click", ".warranties-ul li", function () {
  (0, _jquery2.default)(this).find(".warranties-sub-menu").slideToggle();
});